import Svg, { Circle, Path } from "react-native-svg";

import type { CourseIconId } from "@/lib/training/types";

// Stroke icons ported verbatim from the inline SVGs in CPR_Course_Module1.html.
// Each entry is the set of <Path>/<Circle> primitives drawn inside a 24x24 box.
// `play` is the only filled glyph.

type Props = { id: CourseIconId; size?: number; color: string };

export function CourseIcon({ id, size = 22, color }: Props) {
    const stroke = color;
    const sw = 2.2;
    const common = {
        stroke,
        strokeWidth: sw,
        fill: "none" as const,
        strokeLinecap: "round" as const,
        strokeLinejoin: "round" as const
    };

    switch (id) {
        case "list":
            return (
                <Svg width={size} height={size} viewBox="0 0 24 24">
                    <Path {...common} d="M4 6h16M4 12h16M4 18h10" />
                </Svg>
            );
        case "checkSquare":
            return (
                <Svg width={size} height={size} viewBox="0 0 24 24">
                    <Path {...common} d="M9 11l3 3L22 4" />
                    <Path
                        {...common}
                        d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"
                    />
                </Svg>
            );
        case "target":
            return (
                <Svg width={size} height={size} viewBox="0 0 24 24">
                    <Path {...common} d="M12 2v4M12 18v4M2 12h4M18 12h4" />
                    <Circle {...common} cx={12} cy={12} r={4} />
                </Svg>
            );
        case "bolt":
            return (
                <Svg width={size} height={size} viewBox="0 0 24 24">
                    <Path {...common} d="M13 2 4 14h7l-2 8 9-12h-7z" />
                </Svg>
            );
        case "drop":
            return (
                <Svg width={size} height={size} viewBox="0 0 24 24">
                    <Path {...common} d="M12 21s-7-4.5-7-10a7 7 0 0 1 14 0c0 5.5-7 10-7 10z" />
                </Svg>
            );
        case "dropLine":
            return (
                <Svg width={size} height={size} viewBox="0 0 24 24">
                    <Path {...common} d="M12 21s-7-4.5-7-10a7 7 0 0 1 14 0c0 5.5-7 10-7 10z" />
                    <Path {...common} d="M9 11h6" />
                </Svg>
            );
        case "person":
            return (
                <Svg width={size} height={size} viewBox="0 0 24 24">
                    <Path
                        {...common}
                        d="M12 2a7 7 0 0 0-4 12.7c.6.5 1 1.3 1 2.1V17h6v-.2c0-.8.4-1.6 1-2.1A7 7 0 0 0 12 2z"
                    />
                    <Path {...common} d="M9 21h6" />
                </Svg>
            );
        case "activity":
            return (
                <Svg width={size} height={size} viewBox="0 0 24 24">
                    <Path {...common} d="M3 12h4l2 5 4-12 2 7h6" />
                </Svg>
            );
        case "check":
            return (
                <Svg width={size} height={size} viewBox="0 0 24 24">
                    <Path {...common} d="M20 6 9 17l-5-5" />
                </Svg>
            );
        case "clock":
            return (
                <Svg width={size} height={size} viewBox="0 0 24 24">
                    <Circle {...common} cx={12} cy={12} r={9} />
                    <Path {...common} d="M12 7v5l3 2" />
                </Svg>
            );
        case "alert":
            return (
                <Svg width={size} height={size} viewBox="0 0 24 24">
                    <Path
                        {...common}
                        d="M12 9v4M12 17h.01M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z"
                    />
                </Svg>
            );
        case "bulb":
            return (
                <Svg width={size} height={size} viewBox="0 0 24 24">
                    <Path
                        {...common}
                        d="M9 18h6M10 22h4M12 2a7 7 0 0 0-4 12.7c.6.5 1 1.3 1 2.1V17h6v-.2c0-.8.4-1.6 1-2.1A7 7 0 0 0 12 2z"
                    />
                </Svg>
            );
        case "heart":
            return (
                <Svg width={size} height={size} viewBox="0 0 24 24">
                    <Path {...common} d="M12 21s-7-4.5-7-10a7 7 0 0 1 14 0c0 5.5-7 10-7 10z" />
                </Svg>
            );
        case "chevronRight":
            return (
                <Svg width={size} height={size} viewBox="0 0 24 24">
                    <Path {...common} strokeWidth={2.4} d="M5 12h14M13 6l6 6-6 6" />
                </Svg>
            );
        case "play":
            return (
                <Svg width={size} height={size} viewBox="0 0 24 24">
                    <Path fill={color} d="M8 5v14l11-7z" />
                </Svg>
            );
    }
}
